import { IProductInstallmentsViewConfig } from '../views/product-installments-price/ProductInstallmentsPrice';
import { IShadePickerComponentViewConfig } from '../interfaces/IShadePicker';

export enum ComponentTypes {
    PRODUCT_GRID = 'productGrid',
    PRODUCT_QUICKSHOP = 'productQuickshop',
    PRODUCT_FULL = 'productFull',
    PRODUCT_BRIEF = 'productBrief'
}

export type allowedType =
    | IProductInstallmentsViewConfig
    | IShadePickerComponentViewConfig
    | undefined;

export type ComponentTypesConfigByType = { [K in ComponentTypes]?: allowedType };
